import { ImGroupMemberTypeEnum } from './im-group-member.dto';

export enum ImConferenceMemberStatusEnum {
  Offline = 0,
  Joining = 1,
  Joined = 2,
  Speaking = 3,
}

export interface ImConferenceMemberDto {
  id: number;
  memberID: string;
  memberType: ImGroupMemberTypeEnum;
  status: ImConferenceMemberStatusEnum;
  defaultConf?: boolean;
  current?: boolean;
  deviceId?: string;
  forbidSpeak?: boolean;
}
